/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { Link } from 'react-router-dom';
import PARSE, { domToReact } from "html-react-parser";
import { VscArrowRight } from "react-icons/vsc";
import { NavHashLink } from "react-router-hash-link";
import ApiNew from "./Api";

function SSoft_Our_Services() {
  const [sectionItems, setSectionItems] = useState([]);
  const activeLang = useSelector((state) => state.content.activeLanguage);
  const path = window.location.pathname;

  useEffect(() => {
    const fetchData = async () => {
      const api = new ApiNew();
      const sectionResponse = await api.getSectionDetail({
        language: activeLang,
      });
      const sectionData = sectionResponse;

      setSectionItems(sectionData.data.results[0]);
    };

    fetchData();
  }, [activeLang]);

  let titles;
  let articles;
  const images = [];
  if (sectionItems) {
    const secWidgets = sectionItems.widgets;

    secWidgets?.forEach((data, id) => {
      const secWidgetContents = data.widget_contents;

      switch (id) {
        case 0:
          images.push(...secWidgetContents);
          break;
        case 1:
          titles = data?.widget_contents[0]?.article_language;
          break;
        case 2:
          articles = secWidgetContents;
          break;
        default:
          break;
      }
    });
  }

  const options = {
    replace: ({ attribs, children }) => {
      if (!attribs) {
        return;
      }

      if (attribs.style === "color:#E12726;") {
        // console.log('attribs ', attribs);
        return (
          <span className="text-[#E12726] font-semibold">
            {domToReact(children, options)}
          </span>
        );
      }
    },
    //
  };

  return (
    <div
      id={`${sectionItems?.slug_name}`}
      className="w-full h-full relative bg-white"
    >
      <div className="py-[120px] section-container section-margin-x">
        {/* Section Heading */}
        <div className="mb-12 max-w-[922px] mx-auto">
          <h1 className="header-style-non-hero text-newDarkBlue mb-4 text-center">
            {titles?.title}
          </h1>
          {/* {titles?.content && ( */}
          <p className="subheader-style-non-hero text-center max-w-3xl items-center justify-center mx-auto">
            {PARSE(titles?.content || "")}
          </p>
          {/* )} */}
        </div>

        {/* Grid of Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8">
          {articles &&
            articles.map((article) => {
              const icon = article.assets[0]?.file_small;
              const iconDesc = article.assets[0]?.description;
              const { article_language } = article;

              return (
                <div
                  key={article.id}
                  className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col"
                  // Optional: inline style for precise control (e.g., min height)
                  style={{
                    minHeight: article_language?.summary ? "280px" : "auto",
                  }}
                >
                  {/* Icon */}
                  {icon && (
                    <div className="mb-4">
                      <img
                        src={icon}
                        alt={iconDesc || "Solution icon"}
                        className="w-12 h-12 sm:w-16 sm:h-16 object-contain"
                      />
                    </div>
                  )}

                  {/* Title & Description */}
                  <div className="flex-grow">
                    <h2 className="content-header-style-non-hero text-newDarkBlue mb-2">
                      {article_language?.title}
                    </h2>
                    <p className="content-subheader-style-non-hero mb-4">
                      {PARSE(article_language?.content, options)}
                    </p>
                  </div>

                  {/* Learn More Link */}
                  {article_language?.summary && (
                    <NavHashLink
                      smooth
                      to={article_language?.path || "/"}
                      className=" leading-[150%]  space-x-[10px] flex items-center "
                    >
                      <span className="text-[#E12726] text-[16px]">
                        {article_language.summary}
                      </span>
                      <VscArrowRight className="text-[#E12726]" />
                    </NavHashLink>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default SSoft_Our_Services;
